<template>
  <div class="breadcrumbs">
    <ul itemtype="http://schema.org/BreadcrumbList" itemscope="1">
      <li
        itemtype="http://schema.org/ListItem"
        itemscope="1"
        itemprop="itemListElement"
        v-if="homeLink"
      >
        <a itemprop="item" href="/" :title="getHomepageUrl()">
          <span itemprop="name">{{ getHomepageUrl() }}</span>
        </a>
        <meta content="1" itemprop="position" />
      </li>
      <template v-if="items">
        <li
          itemtype="http://schema.org/ListItem"
          itemscope="1"
          itemprop="itemListElement"
          v-for="(crumb, idx) in items"
          :key="idx"
        >
          <template v-if="crumb.link != ''">
            <a itemprop="item" :href="crumb.link" :title="crumb.name">
              <span itemprop="name">{{ crumb.name }}</span>
            </a>
          </template>
          <template v-else>
            <span itemprop="item">
              <span itemprop="name">{{ crumb.name }}</span>
            </span>
          </template>
          <meta :content="idx + 2" itemprop="position" />
        </li>
      </template>
      <template v-if="locid">
        <li
          itemtype="http://schema.org/ListItem"
          itemscope="1"
          itemprop="itemListElement"
          v-for="(crumb, idx) in breadcrumbs"
          :key="idx"
        >
          <template v-if="crumb.link != ''">
            <template v-if="!activeTail">
              <template v-if="idx != breadcrumbs.length - 1">
                <a
                  itemprop="item"
                  :href="crumb.link"
                  :title="crumb.name"
                  rel="nofollow"
                >
                  <span itemprop="name">{{ crumb.name }}</span>
                </a>
              </template>
              <template v-else>
                <span itemprop="name">{{ crumb.name }}</span>
              </template>
            </template>
            <template v-else>
              <a
                itemprop="item"
                :href="crumb.link"
                :title="crumb.name"
                rel="nofollow"
              >
                <span itemprop="name">{{ crumb.name }}</span>
              </a>
            </template>
          </template>
          <template v-else>
            <span itemprop="item">
              <span itemprop="name">{{ crumb.name }}</span>
            </span>
          </template>
          <meta :content="idx + 2" itemprop="position" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import * as CONFIG from ".././config.js";
import * as GEOSTRUCTURE from "../../../geotree.js";

export default {
  props: {
    items: Array,
    extraItem: Array,
    locid: String,
    guide: Boolean,
    homeLink: Boolean,
    activeTail: Boolean
  },
  data: () => ({
    geostruct: GEOSTRUCTURE.geostruktura,
    breadcrumbs: []
  }),
  methods: {
    getHomepageUrl() {
      let serviceName = CONFIG.serwis;
      let subserviceName = CONFIG.podserwis;
      return subserviceName + "." + serviceName.charAt(0).toUpperCase() + serviceName.slice(1);
    },

    breadCrumbs(locid, geoStruct) {
      let extraCrumb = this.extraItem;
      let crumbsArr = [];
      let offersLinkPrefix = "/oferta/szukaj.xml?locid=";

      if (extraCrumb) {
        for (let x = 0; x < extraCrumb.length; x++) {
          let item = extraCrumb[x];
          crumbsArr.push({ name: item.name, link: item.link });
        }
      }

      for (let i = 0; i < geoStruct.Country.Region.length; i++) {
        let elem = geoStruct.Country.Region[i];

        if (elem.locID == locid) {
          if (this.guide) {
            crumbsArr.push({ name: elem.name, link: elem.url });
          } else {
            crumbsArr.push({
              name: elem.name,
              link: offersLinkPrefix + elem.locID
            });
          }
          this.breadcrumbs = crumbsArr;
          return this.breadcrumbs;
        }

        if (elem.Miniregion) {
          for (let j = 0; j < elem.Miniregion.length; j++) {
            let elem2 = elem.Miniregion[j];

            if (elem2.locID == locid) {
              if (this.guide) {
                crumbsArr.push(
                  { name: elem.name, link: elem.url },
                  { name: elem2.name, link: elem2.url }
                );
              } else {
                crumbsArr.push(
                  { name: elem.name, link: offersLinkPrefix + elem.locID },
                  { name: elem2.name, link: offersLinkPrefix + elem2.locID }
                );
              }
            }

            if (elem2.Areatown) {
              for (let k = 0; k < elem2.Areatown.length; k++) {
                let elem3 = elem2.Areatown[k];

                if (elem3.locID == locid) {
                  if (this.guide) {
                    crumbsArr.push(
                      { name: elem.name, link: elem.url },
                      { name: elem2.name, link: elem2.url },
                      { name: elem3.name, link: elem3.url }
                    );
                  } else {
                    crumbsArr.push(
                      { name: elem.name, link: offersLinkPrefix + elem.locID },
                      {
                        name: elem2.name,
                        link: offersLinkPrefix + elem2.locID
                      },
                      { name: elem3.name, link: offersLinkPrefix + elem3.locID }
                    );
                  }
                }

                if (elem3.Place) {
                  for (let l = 0; l < elem3.Place.length; l++) {
                    let elem4 = elem3.Place[l];

                    if (elem4.locID == locid) {
                      if (this.guide) {
                        crumbsArr.push(
                          { name: elem.name, link: elem.url },
                          { name: elem2.name, link: elem2.url },
                          { name: elem3.name, link: elem3.url },
                          { name: elem4.name, link: elem4.url }
                        );
                      } else {
                        crumbsArr.push(
                          {
                            name: elem.name,
                            link: offersLinkPrefix + elem.locID
                          },
                          {
                            name: elem2.name,
                            link: offersLinkPrefix + elem2.locID
                          },
                          {
                            name: elem3.name,
                            link: offersLinkPrefix + elem3.locID
                          },
                          {
                            name: elem4.name,
                            link: offersLinkPrefix + elem4.locID
                          }
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.breadcrumbs = crumbsArr;
    }
  },
  mounted() {
    let geoStruct = this.geostruct.geotree;
    let locid = this.locid;
    this.breadCrumbs(locid, geoStruct);
  },
  watch: {
    locid: function() {
      let geoStruct = this.geostruct.geotree;
      let locid = this.locid;
      this.breadCrumbs(locid, geoStruct);
    }
  },
  updated() {
    let that = this;
    this.$nextTick(function() {
      that.$root.$emit("update:breadcrumbsReady", true);
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/T1Breadcrumbs/T1BreadcrumbsStyles";
</style>
